import * as React from "react";
import './CustomCheckbox.css';
export default function CustomCheckBoxWithCustomWidget({ value, setValue, childText }) {
  const handleCheckboxChange = () => {
    setValue(!value);
  };
  return (
      <label className="custom-checkbox-container">
      <input type="checkbox" checked={value} onChange={handleCheckboxChange} className="hidden-checkbox"/>
      <span className={`custom-checkbox ${value ? 'checked' : ''}`} />
      {childText}
    </label>
  );
}
